module.exports = __webpack_public_path__ + "teqbahn-assets/media/18.50bd6777.jpg";